// @ts-nocheck
import { memo } from 'react'
import { UserMessage } from '@/components/chat/user-message'
import { PharosResponse } from '@/components/chat/pharos-response'

export const ChatMessages = memo(function ChatMessages({
  messages,
  isLoading,
  onSuggestionClick,
  onAddToReport,
  sessionId,
}) {
  return (
    <div className="space-y-1 py-2" data-testid="chat-messages-list">
      {messages.map((msg, i) => {
        const isLast = i === messages.length - 1
        const isStreaming = isLast && isLoading && msg.role === 'assistant'

        return msg.role === 'user' ? (
          <UserMessage key={msg.id || i} message={msg} />
        ) : (
          <PharosResponse
            key={msg.id || i}
            message={msg}
            isStreaming={isStreaming}
            isLast={isLast}
            onSuggestionClick={onSuggestionClick}
            onAddToReport={onAddToReport}
            sessionId={sessionId}
          />
        )
      })}
    </div>
  )
})
